import React from 'react'

function Health() {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                fontSize: "24px"
            }}
        >
            🚀 Welcome to sportspik 🚀
        </div>

    )
}

export default Health
